
import { defineComponent, watch, ref } from 'vue';
import { useAPI } from '@/modules/api-module';
import { usePageList } from '@/modules/pages/page-list-module';
import ProgressSpinner from 'primevue/progressspinner';
import PageSearchBar from './search/PageSearchBar.vue';

export default defineComponent({
  name: 'AppListPage',

  components: { PageSearchBar, ProgressSpinner },

  props: {
    title: String,
    perspective: String,
    showSearch: Boolean,
    searchType: String,
    searchEndpoint: String,
    pageListEndpoint: String,
    showSearchBarwithBrowse: Boolean,
  },

  emits: ['search', 'searchResult', 'clearSearch'],

  setup(props, { emit }) {
    const loading = ref(!!props.pageListEndpoint);
    const { data: searchResults, execute: executeSearchQuery } = useAPI(props.searchEndpoint || '', false);
    const { loading: loadingPageList, list: brands } = usePageList(props.pageListEndpoint || '', !!props.pageListEndpoint);

    const performSearch = (e: any) => {
      emit('search', e);

      loading.value = true;
      executeSearchQuery({ params: { name: e.term } });
    };

    const clearSearch = () => {
      emit('clearSearch');
    };

    watch(loadingPageList, () => {
      loading.value = loadingPageList.value;
      emit('searchResult', brands.value);
    });

    watch(searchResults, () => {
      emit('searchResult', searchResults.value);
      loading.value = false;
    });

    return {
      loading,
      performSearch,
      clearSearch,
    };
  },
});
